(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kp-header-bak-0929"]) return;
  try {
    
(() => {
  const init = () => {
    const header = document.querySelector('.kps-header');
    if (!header || header.dataset.initialized) return;
    header.dataset.initialized = 'true';
    const overlay = header.querySelector('.search-results-overlay');
    if (overlay) overlay.addEventListener('click', () => overlay.classList.remove('active'));
    const badge = header.querySelector('[data-header-cart-count]');
    if (badge) {
      const syncCount = () => badge.classList.toggle('kps-count-empty', Number(badge.textContent.trim()) === 0);
      syncCount();
      new MutationObserver(syncCount).observe(badge, {childList:true, characterData:true, subtree:true});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kp-header-before-flowers-0929"]) return;
  try {
    
(() => {
  const init = () => {
    const header = document.querySelector('.kps-header');
    if (!header || header.dataset.initialized) return;
    header.dataset.initialized = 'true';
    const overlay = header.querySelector('.search-results-overlay');
    if (overlay) overlay.addEventListener('click', () => overlay.classList.remove('active'));
    const badge = header.querySelector('[data-header-cart-count]');
    if (badge) {
      const syncCount = () => badge.classList.toggle('kps-count-empty', Number(badge.textContent.trim()) === 0);
      syncCount();
      new MutationObserver(syncCount).observe(badge, {childList:true, characterData:true, subtree:true});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kp-header-before-links"]) return;
  try {
    
(() => {
  const init = () => {
    const header = document.querySelector('.kps-header');
    if (!header || header.dataset.initialized) return;
    header.dataset.initialized = 'true';
    const overlay = header.querySelector('.search-results-overlay');
    if (overlay) overlay.addEventListener('click', () => overlay.classList.remove('active'));
    const badge = header.querySelector('[data-header-cart-count]');
    if (badge) {
      const syncCount = () => badge.classList.toggle('kps-count-empty', Number(badge.textContent.trim()) === 0);
      syncCount();
      new MutationObserver(syncCount).observe(badge, {childList:true, characterData:true, subtree:true});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kp-unified-header"]) return;
  try {
    
(() => {
  const init = () => {
    const header = document.querySelector('.kps-header');
    if (!header || header.dataset.initialized) return;
    header.dataset.initialized = 'true';
    const overlay = header.querySelector('.search-results-overlay');
    if (overlay) overlay.addEventListener('click', () => overlay.classList.remove('active'));
    const badge = header.querySelector('[data-header-cart-count]');
    if (badge) {
      const syncCount = () => badge.classList.toggle('kps-count-empty', Number(badge.textContent.trim()) === 0);
      syncCount();
      new MutationObserver(syncCount).observe(badge, {childList:true, characterData:true, subtree:true});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
